import { Component } from '@theme/component';

/**
 * Keeps the active sibling link centred when the links overflow and scroll horizontally.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} links - The scrollable links container.
 *
 * @extends {Component<Refs>}
 */
class ProductSiblings extends Component {
  requiredRefs = ['links'];

  /** @type {ResizeObserver | null} */
  #resizeObserver = null;

  connectedCallback() {
    super.connectedCallback();

    // Also fires once the links become visible (e.g. inside a dialog that opens later)
    this.#resizeObserver = new ResizeObserver(() => this.#centerActiveLink());
    this.#resizeObserver.observe(this.refs.links);
  }

  updatedCallback() {
    this.#centerActiveLink();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#resizeObserver?.disconnect();
    this.#resizeObserver = null;
  }

  #centerActiveLink() {
    const { links } = this.refs;
    const activeLink = links.querySelector('.product-siblings__link.is-active');
    if (!activeLink || links.scrollWidth <= links.clientWidth) return;

    const linksRect = links.getBoundingClientRect();
    const activeRect = activeLink.getBoundingClientRect();
    const offset = activeRect.left + activeRect.width / 2 - (linksRect.left + linksRect.width / 2);

    links.scrollBy({ left: offset, behavior: 'instant' });
  }
}

if (!customElements.get('product-siblings')) {
  customElements.define('product-siblings', ProductSiblings);
}
